<template>
  <main-layout
    controlsBg="light"
    :hasControlsBar="false"
    :breadcrumb="breadcrumb">
    <div class="container">
      <grid-row class="margin-top-xl" column-align="center">
        <grid-col col-size="4">
          <div id="header">
            <h1 class="header-title">
              <chevron @click="$router.push({name: 'AnalyticsList'})"/>
              Resultados de la Analítica
            </h1>
          </div>
        </grid-col>
      </grid-row>

      <grid-row class="margin-top-xl" column-align="center">
        <grid-col col-size="4">
          <div class="list-of-categories">
            <div class="categories">
              <div class="category-item-container" v-for="(category, index) in categories" :key="index">
                <div class="category-item" @click="toggleCategory(category.categoryId)">
                  <div class="category-info">
                    <div class="color-circle" :style="{ backgroundColor: getCategoryColor(category.color) }"></div>
                    <div class="category-name">
                      {{ category.categoryName || category.name || getCategoryName(category.categoryId) }}
                    </div>
                  </div>
                  <div class="category-toggle">
                    <span v-if="expandedCategories.includes(category.categoryId)">▲</span>
                    <span v-else>▼</span>
                  </div>
                </div>
                <div class="biomarkers-list" v-if="expandedCategories.includes(category.categoryId)">
                  <div v-if="!category.biomarkerDetails || category.biomarkerDetails.length === 0" class="no-biomarkers">
                    Sin datos recuperados para esta categoría
                  </div>
                  <div v-for="biomarker in category.biomarkerDetails" :key="biomarker.biomarkerId" class="biomarker-item">
                    <div class="color-circle-small" :style="{ backgroundColor: getCategoryColor(biomarker.statusColor) }"></div>
                    <div class="biomarker-info">
                      <span class="biomarker-name">{{ biomarker.description || 'Biomarcador ' + biomarker.biomarkerId }}</span>
                      <span class="biomarker-value" v-if="biomarker.value !== null">{{ biomarker.value }}</span>
                      <span class="biomarker-value empty" v-else>Sin datos</span>
                      <span class="biomarker-unit">{{ biomarker.unit}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="categories.length === 0" class="no-data">
              No hay categorías disponibles o cargando...
            </div>
          </div>
        </grid-col>
      </grid-row>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Chevron from '@/components/shared/Chevron';

export default {
  name: 'ListOfCategories',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    Chevron
  },
  data() {
    return {
      categories: [],
      expandedCategories: [],
      analyticId: null,
      breadcrumb: [
        {link: '/workspace', name: 'Workspace'},
        {link: '/analytics/list', name: 'Analíticas'},
        {link: '', name: 'Resultados', disabled: true}
      ]
    };
  },
  created() {
    this.analyticId = this.$route.params.analyticId;
    this.fetchCategories();
  },
  methods: {
    toggleCategory(categoryId) {
      const index = this.expandedCategories.indexOf(categoryId);
      if (index > -1) {
        this.expandedCategories.splice(index, 1);
      } else {
        this.expandedCategories.push(categoryId);
      }
    },
    async fetchCategories() {
      if (!this.analyticId) {
        console.error("No se ha proporcionado un analyticId en la ruta.");
        return;
      }
      try {
        // Ajusta la ruta base de tu API si difiere (p.ej. /api/web/xugarhero/...)
        const response = await this.$http.get(`/api/web/xugarhero/analytics/evaluation/analytic/${this.analyticId}/all-categories`);
        // O si devuelve directamente el array:
        this.categories = Array.isArray(response.data) ? response.data : (response.data.categories || []);
      } catch (error) {
        console.error("Error al cargar las categorías:", error);
      }
    },
    getCategoryName(categoryId) {
      const names = {
        1: 'Salud Cardiovascular',
        2: 'Salud Muscular y Ósea',
        3: 'Salud Renal',
        4: 'Salud Hepática',
        5: 'Salud Hematológica',
        6: 'Salud Inmunológica',
        7: 'Salud Metabólica y Endocrina'
      };
      return names[categoryId] || 'Categoría ' + categoryId;
    },
    getCategoryColor(colorEnum) {
      const colors = {
        'GREEN': '#28a745',
        'ORANGE': '#fd7e14',
        'RED': '#dc3545',
        'GREY': '#6c757d'
      };
      return colors[colorEnum] || '#6c757d';
    }
  }
};
</script>

<style scoped lang="scss">
.list-of-categories {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.category-item-container {
  border-bottom: 1px solid #f0f0f0;
}

.category-item-container:last-child {
  border-bottom: none;
}

.category-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.category-item:hover {
  background-color: #f9f9f9;
}

.category-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.category-toggle {
  color: #888;
  font-size: 0.9em;
}

.biomarkers-list {
  padding: 0 15px 15px 54px;
  background-color: #fafafa;
}

.biomarker-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px dashed #eee;
}

.biomarker-item:last-child {
  border-bottom: none;
}

.color-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
}

.color-circle-small {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.biomarker-info {
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 0.95em;
  color: #555;
}

.biomarker-name {
  flex: 1;
  padding-right: 15px;
  font-weight: 500;
}

.biomarker-value {
  width: 100px;
  text-align: left;
  font-weight: bold;
}

.biomarker-value.empty {
  font-weight: normal;
  font-style: italic;
  color: #999;
}

.category-name {
  font-size: 1.1em;
  font-weight: 500;
  color: #333;
}

.no-data {
  text-align: center;
  padding: 20px;
  color: #888;
}

.no-biomarkers {
  padding: 12px 0;
  color: #999;
  font-style: italic;
  font-size: 0.9em;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/analytics/ListOfCategories.vue